import stubList from './stub';
import config from './../../config/config.js';

const debugLogArray = (ary, cnt) => {
  var i = 1;
  var blank = " ";
  while (i < cnt) {
    blank += " ";
    i++;
  }
  
  for (var j in ary) {
    if ((ary[j] instanceof Array) || (ary[j] instanceof Object)) {
      console.log(blank + j + " >> ");
      debugLogArray((ary[j]), (cnt+1));
    }
    else {
      console.log(blank + j + " => " + ary[j]);
    }
  }
};

export function debugLogRequest (param) {
  if(config.apiLogFlag){
    console.log("-----API DEBUG LOG IN-----");
    console.log("##  " + getFunctionName(param.url) + "  ##");
    debugLogArray(param, 1);
  }
}

export function debugLogResponse (param) {
  if(config.apiLogFlag){
    console.log("-----API DEBUG LOG OUT-----");
    console.log("##  " + getFunctionName(param.request.responseURL) + "  ##");
    debugLogArray(param, 1);
  }
}

export function requestURL (request) {
  if(request.url.indexOf("http://") !== 0 && request.url.indexOf("https://") !== 0){
    request.url = config.API_URL + request.url;
  }
  return request;
}

export function getFunctionName (url) {
  return url.split('/')[url.split('/').length - 1];
}

export function getStub (name) {
  var ret = "";
  var stub = stubList.filter((item) => {
    return item === name;
  });
  if(stub.length === 1){
    ret = require("./stub/" + stub + ".js").default;
  }
  return ret;
}
